import axios from './axios';
import vueMeta from './vue-meta';
import stripe from './stripe';

export default {
  axios,
  vueMeta,
  stripe,
};
